<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import Icon from 'next/icon/Icon.vue';
import { isConnected } from './inboxStatusMeta';

const props = defineProps({
  inboxId: { type: [Number, String], required: true },
});

const route = useRoute();
const byInboxId = useMapGetter('bmtInboxHealth/byInboxId');

const status = computed(() => byInboxId.value?.[props.inboxId]?.status);
// Banner permanente (sem dismiss) enquanto o canal NAO estiver conectado:
// o atendente PRECISA saber que pode estar perdendo mensagens.
// Usa isConnected (aceita 'connected' e o legado 'open') -> defensivo a rolling-deploy.
const isDisconnected = computed(
  () => !!status.value && !isConnected(status.value)
);

const accountId = computed(() => route.params.accountId);
const qrLink = computed(
  () =>
    `/app/accounts/${accountId.value}/settings/inboxes/${props.inboxId}/whatsapp-qr`
);
</script>

<template>
  <div
    v-if="isDisconnected"
    class="sticky top-0 z-20 flex items-center gap-3 px-4 py-2.5 bg-n-ruby-5/60 border-b border-n-ruby-7"
  >
    <Icon icon="i-woot-alert" class="size-5 text-n-ruby-9 shrink-0" />
    <div class="flex flex-col flex-1 min-w-0">
      <span class="text-sm font-semibold text-n-ruby-12">
        Canal desconectado
      </span>
      <span class="text-xs text-n-ruby-11">
        O cliente pode estar enviando mensagens que você não está recebendo.
        Reconecte via QR Code.
      </span>
    </div>
    <router-link
      :to="qrLink"
      class="text-xs font-semibold underline whitespace-nowrap text-n-ruby-12 hover:text-n-ruby-11"
    >
      Configurar canal →
    </router-link>
  </div>
</template>
